export enum NotificationEvents {
  LEGACY_BANK_APPROVED = 'bank_approved',
  LEGACY_BANK_REJECTED = 'bank_rejected',
  LEGACY_OUTSTANDING_CRONJOBS = 'outstanding_cronjobs',
  LEGACY_PAYMENT_SUCCESS = 'payment_success',
  LEGACY_PAYMENT_FAILURE = 'payment_failure',
  LEGACY_SERVICE_ENABLED = 'service_enabled',
  LEGACY_SERVICE_DISABLED = 'service_disabled',
  LEGACY_INCOMING_PAYMENT = 'incoming_payment',
  LEGACY_WALLET_DEDUCTION = 'wallet_deduction',

  LINE_DOWN = 'lineDown',
  LINE_DOWN_QUOTA = 'lineDownQuota',
  LINE_UP = 'lineUp',
}
